module.exports = __webpack_public_path__ + "static/img/nishikong.a40fe02.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/nishikong.png
// module id = A8Vt
// module chunks = 1